<template>
  <div class="page">
    <!-- 统一风格页头 -->
    <div class="page-header">
      <div class="header-left">
        <h1 class="page-title">抽卡權限記錄</h1>
      </div>
    </div>

    <div class="layout">
      <!-- 统一风格搜索区 -->
      <div class="search-card">
        <div class="search-row">

          <el-input
              v-model="listQuery.userNoLike"
              placeholder="學生賬號"
              prefix-icon="el-icon-search"
          ></el-input>
          <el-input
              v-model="listQuery.nameLike"
              placeholder="學生姓名"
              prefix-icon="el-icon-search"
          ></el-input>
          <div class="search-buttons">
            <el-button size="small" type="warning" @click="onSearch" icon="el-icon-search">搜尋</el-button>
            <el-button size="small" @click="onReset" icon="el-icon-refresh">重置</el-button>
          </div>
        </div>
      </div>

      <!-- 统一风格 PC表格 + 手机卡片 -->
      <div class="table-container">
        <!-- PC端表格（≥768px显示） -->
        <div class="pc-table">
          <el-table
              @sort-change="handleSortChange"
              :data="tableData"
              style="width:100%"
              border
              stripe
              size="small"
              :empty-text="tableData.length === 0 ? '暫無數據' : ''"
              show-summary
          :summary-method="getSummary"
          >
          <el-table-column label="#" type="index" width="50" align="center"></el-table-column>
          <el-table-column prop="userName" label="學生姓名" align="center"  min-width="120"></el-table-column>
          <el-table-column prop="userNo" label="學生賬號" align="center"  min-width="120"></el-table-column>
          <el-table-column prop="studentCode" label="學生編號" align="center"  min-width="120"></el-table-column>
          <el-table-column prop="num" label="抽卡機會" align="center"  min-width="120">
            <template slot-scope="{row}">
              <span>{{ row.num > 0 ? '+' + row.num : row.num }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createdAt" label="發放時間" align="center"  min-width="120">
            <template slot-scope="{ row }">
              {{  formatDateTime(row.createdAt.date) }}
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="備註" align="center"  min-width="120"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <!-- 分页 -->
    <div class="pagination-wrap">
      <Pagination
          v-show="total > 0"
          :total="total"
          :page.sync="listQuery._page"
          :limit.sync="listQuery._limit"
          @pagination="getCardsUser"
      />
    </div>

    <!-- 删除弹窗 -->
    <deleteDialog
        titleCh="您確定要刪除此卡片嗎？"
        :centerDialogVisible="centerDialogVisible"
        @confirmFunction="confirmFunction"
        @onCancelButton="onCancelButton"
    ></deleteDialog>

  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { getCardProperty, getCardTitle,getCardsNumUser } from "@/api/setting";
import deleteDialog from "@/components/deleteDialog";
import {formatDateTime} from "@/filters";
export default {
  components: { deleteDialog, Pagination },
  data() {
    return {
      total: 0,
      staffId: null,
      centerDialogVisible: false,
      addDialogVisible: false,
      editDialogVisible: false,
      currentId: null,
      listQuery: {
        nameLike: null,
        userNoLike: null,
        orderBy: null,
        _page: 1,
        _limit: 10,
      },
      form: {
        name: '',
        titleId: null,
        propertyId: null,
        content: '',
        probability: '',
        imageUrl: '',
      },
      editForm: {
        name: '',
        titleId: null,
        propertyId: null,
        content: '',
        probability: '',
        image: '',
      },
      rules: {
        name: [{ required: true, message: '請輸入名稱', trigger: 'blur' }],
        titleId: [{ required: true, message: '請選擇主題', trigger: 'change' }],
        propertyId: [{ required: true, message: '請選擇屬性', trigger: 'change' }],
        probability: [
          { required: true, message: '請輸入概率', trigger: 'blur' }
        ]
      },
      tableData: [],
      cardTitle: [],
      cardProperty: [],
    };
  },
  created() {
    this.getCardsUser();
    this.getCardTitle();
    this.getCardProperty();
  },
  methods: {
    formatDateTime(cellValue) {
      return formatDateTime(new Date(cellValue), 'dd/MM/yyyy HH:mm:ss');
    },

    // ===================== 表格汇总计算 =====================
    getSummary(param) {
      const { data } = param;
      const sums = [];
      // 第一列显示 汇总
      sums[0] = '匯總';
      // 其他列空
      sums[1] = '';
      sums[2] = '';
      sums[3] = '';
      // 第5列（抽卡机会）计算总和
      let totalNum = 0;
      data.forEach(item => {
        totalNum += Number(item.num || 0);
      });
      sums[4] = totalNum > 0 ? '+' + totalNum : totalNum;
      // 剩余列空
      sums[5] = '';
      sums[6] = '';
      return sums;
    },

    // 根据ID获取主题名称
    getTitleName(titleId) {
      const item = this.cardTitle.find(t => t.id === titleId);
      return item ? item.name : '-';
    },
    // 根据ID获取属性名称
    getPropertyName(propertyId) {
      const item = this.cardProperty.find(p => p.id === propertyId);
      return item ? item.name : '-';
    },

    // 基础功能
    handleSortChange(col) {
      this.listQuery.orderBy = col.order ? `${col.prop} ${col.order === "descending" ? "desc" : "asc"}` : null;
      this.listQuery._page = 1;
      this.getCardsUser();
    },
    onSearch() {
      this.listQuery._page = 1;
      this.getCardsUser();
    },
    onReset() {
      Object.keys(this.listQuery).forEach(k => {
        this.listQuery[k] = null;
        if (k === "_page") this.listQuery[k] = 1;
        if (k === "_limit") this.listQuery[k] = 10;
      });
      this.getCardsUser();
    },
    onCancelButton() {
      this.centerDialogVisible = false;
    },
    confirmFunction() {
      // 删除逻辑
    },
    onDeleteButton(id) {
      this.staffId = id;
      this.centerDialogVisible = true;
    },
    getCardsUser() {
      const params = { ...this.listQuery, _page: this.listQuery._page - 1 };
      Object.keys(params).forEach(key => {
        if (params[key] == null) delete params[key];
      });
      getCardsNumUser(params).then(v => {
        this.tableData = v.data || [];
        this.total = +v.headers["x-total-count"] || 0;
      });
    },
    getCardTitle() {
      getCardTitle().then(v => {
        this.cardTitle = v.data || [];
      });
    },
    getCardProperty() {
      getCardProperty().then(v => {
        this.cardProperty = v.data || [];
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  padding: 16px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
  padding-bottom: 12px;
  border-bottom: 1px solid #e4e7ed;

  .page-title {
    font-size: 20px;
    font-weight: 600;
    color: #B62D2E;
    margin: 0;
  }
}

.layout {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.search-card {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 6px;
  margin-bottom: 20px;

  .search-row {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    align-items: center;

    .el-input, .el-select {
      flex: 1;
      min-width: 160px;
    }

    .search-buttons {
      display: flex;
      gap: 8px;
    }
  }
}

.table-container {
  width: 100%;
}

.pagination-wrap {
  text-align: center;
  padding: 10px 0;
}

.dialog-footer {
  text-align: right;
}

@media (max-width: 768px) {
  .page { padding: 8px; }
  .layout { padding: 12px; }
  .search-row { flex-direction: column; align-items: stretch; }
  .pc-table { display: none; }
}
</style>